import { Controller } from "@hotwired/stimulus";

// Galerie des captures mobiles de la landing : vignettes + visionneuse plein
// écran (clavier ← → Échap).
export default class extends Controller {
  static targets = ["lightbox", "slide", "label", "counter"];

  connect() {
    this.index = 0;
    this.onKeydown = this.handleKeydown.bind(this);
    document.addEventListener("keydown", this.onKeydown);
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKeydown);
    document.body.style.overflow = "";
  }

  open(event) {
    this.index = Number(event.params.index) || 0;
    this.lightboxTarget.classList.remove("hidden");
    this.lightboxTarget.classList.add("flex");
    document.body.style.overflow = "hidden";
    this.render();
  }

  close() {
    this.lightboxTarget.classList.add("hidden");
    this.lightboxTarget.classList.remove("flex");
    document.body.style.overflow = "";
  }

  previous() {
    this.move(-1);
  }

  next() {
    this.move(1);
  }

  move(step) {
    const count = this.slideTargets.length;
    this.index = (this.index + step + count) % count;
    this.render();
  }

  render() {
    this.slideTargets.forEach((slide, position) => {
      slide.classList.toggle("hidden", position !== this.index);
    });
    this.labelTarget.textContent = this.slideTargets[this.index].alt;
    this.counterTarget.textContent = `${this.index + 1} / ${this.slideTargets.length}`;
  }

  get open$() {
    return !this.lightboxTarget.classList.contains("hidden");
  }

  handleKeydown(event) {
    if (!this.open$) return;
    if (event.key === "Escape") this.close();
    if (event.key === "ArrowRight") this.next();
    if (event.key === "ArrowLeft") this.previous();
  }
}
